const awsExports = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_XeSDryj43",
    "aws_user_pools_web_client_id": "7n34a2nnfav0gfc4374g22dmcd",
    "aws_appsync_apiKey": "",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "oauth": {
        "domain":"ap-southeast-2xesdryj43.auth.ap-southeast-2.amazoncognito.com",
        "scope": ["email", "openid","profile","aws.cognito.signin.user.admin"],
        "redirectSignIn": "localhost:4200",
        "redirectSignOut": "localhost:4200",
        "responseType": "code",
        "client_id": "7n34a2nnfav0gfc4374g22dmcd"
    }
}
;
export default awsExports;